/* eslint react/prop-types: 0 */
import React, { useState, useEffect } from 'react';
import {
  Container,
  Card,
  CardBody,
  Table,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Toast,
  ToastHeader,
  ToastBody,
  CardHeader,
  Badge,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon';
import CloseCircleOutlineIcon from 'mdi-react/CloseCircleOutlineIcon';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DragIcon from 'mdi-react/DragIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router';
import useModal from '../../shared/hooks/useModal';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import Api from '../../util/api';
import skeletonTableLoader from '../../shared/components/custom/SkeletonLoaders';
import Loading from '../../shared/components/custom/Loading';
import NavTab from '../../shared/components/custom/NavTab';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';
import FormCard from '../../shared/components/custom/FormCard';
import GroupForm from './components/GroupForm';
import { partial } from '../../util/translation/translation';
import useConfig from '../../util/useConfig';
import TeamProfileList from '../settings/components/TeamProfileList';
import InfoBox from '../../shared/components/custom/InfoBox';

const AVATAR_COLORS = [
  '#3B82F6',
  '#22C55E',
  '#A855F7',
  '#F97316',
  '#EC4899',
  '#14B8A6',
];

const avatarColorFor = (name) => {
  const str = name || '';
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

const initialsFor = (firstName, lastName) =>
  `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';

const PlayersListPage = () => {
  const config = useConfig();
  const { teamId } = useParams();
  const history = useHistory();
  const [selectedTeam, setSelectedTeam] = useState(
    teamId ? config.teams.find((t) => t.id === teamId) : config.teams[0]
  );
  const [searchPlayers, setSearchPlayers] = useState([]);
  const [selectedTransferPlayer, setSelectedTransferPlayer] =
    useState(undefined);
  const [transferTeams, setTransferTeams] = useState([]);
  const [playerHandleModal, playerVisible, deletePlayerID] = useModal();
  const [groupHandleModal, groupVisible, groupDeleteID] = useModal();
  const [loadingPlayer, setLoadingPlayer] = useState(false);
  const [loadingGroup, setLoadingGroup] = useState(false);
  const [positions, setPositions] = useState([]);
  const [teamLoader, setTeamLoader] = useState();
  const [loadingTransfer, setLoadingTransfer] = useState(false);
  const [players, setPlayers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [tab, setTab] = useState('');
  const [playersFilter, setPlayersFilter] = useState('active');
  const [selectedPlayerIds, setSelectedPlayerIds] = useState([]);
  const [playersOrder, setPlayersOrder] = useState({
    orderBy: 'name',
    desc: false,
  });
  const [groupState, setGroupState] = useState(false);
  const p = partial('PlayerListPage');
  const s = partial('shared');

  const getGroups = async () => {
    setLoadingGroup(true);
    try {
      const resGroups = await Api.club.getSettingsByKey('playerGroup');
      setGroups(
        resGroups.data.map((setting) => {
          const [name, ...values] = setting.value.split(':');
          return {
            id: setting.id,
            order: setting.order,
            name,
            values,
          };
        })
      );
      setLoadingGroup(false);
    } catch (err) {
      toast.error(err || p('fetchingGroupsFailed'));
      setLoadingGroup(false);
    }
  };
  const fetchTeam = async (id) => {
    try {
      setTeamLoader(true);
      const { data: _players } = await Api.players.getPLayersFromNtb(id);
      setPlayers(_players);
      setPositions(_players.map((_p) => _p.position));
      await getGroups();
      setTeamLoader(false);
    } catch (err) {
      setTeamLoader(false);
      toast.error(err || p('fetchingPlayersAndGroupsFailed'));
    }
  };

  const _setSelectedTeam = (team) => () => {
    history.replace(`/players/${team.id}`);
    setSelectedTeam(team);
    fetchTeam(team.id);
  };

  const deletePlayer = async () => {
    playerHandleModal();
    setLoadingPlayer(true);
    try {
      await Api.players.deletePlayer(deletePlayerID);
      toast.success(p('playerDeleted'));
      await fetchTeam(selectedTeam.id);
    } catch (err) {
      toast.error(err || p('deletingPlayerFailed'));
      await fetchTeam(selectedTeam.id);
    }
    setLoadingPlayer(false);
  };

  const updatePlayerActive = async (playerId, nextActive) => {
    const { data: fullPlayer } = await Api.players.getPlayer(playerId);
    await Api.players.updatePlayer({
      id: fullPlayer.id,
      externalProviderId: fullPlayer.externalProviderId,
      firstname: fullPlayer.firstname,
      lastname: fullPlayer.lastname,
      infoUrl: fullPlayer.infoUrl || null,
      fullname: `${fullPlayer.firstname} ${fullPlayer.lastname}`,
      jerseyName: fullPlayer.jerseyName || fullPlayer.lastname,
      position: fullPlayer.position,
      jerseyNumber: fullPlayer.jerseyNumber,
      nationality: fullPlayer.nationality || null,
      dateOfBirth: fullPlayer.dateOfBirth
        ? moment(fullPlayer.dateOfBirth).format('YYYY-MM-DD')
        : undefined,
      imageCrop: fullPlayer.imageCrop || null,
      companyId: fullPlayer.companyId || null,
      shots: fullPlayer.shots,
      weight: fullPlayer.weight,
      height: fullPlayer.height,
      active: nextActive,
      bio: fullPlayer.bio,
      playerStats: fullPlayer.playerStats,
    });
  };

  const toggleActivePlayer = async (player) => {
    setLoadingPlayer(true);
    // player.active (from the players list) is the source of truth here -
    // the single-player fetch below is only used to fill in the other
    // fields the update endpoint requires.
    const nextActive = !player.active;
    try {
      await updatePlayerActive(player.id, nextActive);
      toast.success(nextActive ? p('playerActivated') : p('playerDeactivated'));
      await fetchTeam(selectedTeam.id);
    } catch (err) {
      toast.error(err || p('updatingPlayerFailed'));
    }
    setLoadingPlayer(false);
  };

  const toggleActivePlayers = async (playerIds, nextActive) => {
    setLoadingPlayer(true);
    try {
      await Promise.all(
        playerIds.map((playerId) => updatePlayerActive(playerId, nextActive))
      );
      toast.success(
        nextActive ? p('playersActivated') : p('playersDeactivated')
      );
      setSelectedPlayerIds([]);
      await fetchTeam(selectedTeam.id);
    } catch (err) {
      toast.error(err || p('updatingPlayerFailed'));
    }
    setLoadingPlayer(false);
  };

  const deleteGroup = async () => {
    groupHandleModal();
    setLoadingGroup(true);
    try {
      await Api.club.deleteSetting(groupDeleteID);
      getGroups();
    } catch (err) {
      toast.error(err || p('deletingGroupFailed'));
      getGroups();
    }
  };

  const fetchTransferTeams = async () => {
    try {
      const { data: _transferTeams } = await Api.teams.transferTeams();
      setTransferTeams(_transferTeams);
    } catch (err) {
      toast.error(err || p('fetchingTransferTeamsFailed'));
    }
  };

  const selectTransferPlayer = (player) => {
    setSearchPlayers([]);
    setSelectedTransferPlayer(player);
  };

  useEffect(() => {
    if (selectedTeam) {
      fetchTeam(selectedTeam.id);
    }
    if (transferTeams.length === 0) {
      fetchTransferTeams();
    }
    // fetchTeam/fetchTransferTeams are redefined every render; depending on
    // them would refetch on every render instead of only when
    // selectedTeam/transferTeams change.
    // eslint-disable-next-line
  }, [selectedTeam, transferTeams]);

  useEffect(() => {
    setSelectedPlayerIds([]);
  }, [playersFilter]);

  const handleSort = (field) => {
    setPlayersOrder((prev) => ({
      orderBy: field,
      desc: field === prev.orderBy ? !prev.desc : false,
    }));
  };

  const renderSortIcon = (field) => {
    if (playersOrder.orderBy !== field) {
      return null;
    }
    return playersOrder.desc ? (
      <ArrowDownIcon size={16} />
    ) : (
      <ArrowUpIcon size={16} />
    );
  };

  const sortPlayers = (list) => {
    const sorted = [...list].sort((a, b) => {
      let cmp = 0;
      if (playersOrder.orderBy === 'name') {
        cmp = `${a.firstname} ${a.lastname}`.localeCompare(
          `${b.firstname} ${b.lastname}`
        );
      } else if (playersOrder.orderBy === 'position') {
        cmp = (a.position || '').localeCompare(b.position || '');
      } else if (playersOrder.orderBy === 'jerseyNumber') {
        const aNumber = a.jerseyNumber ?? Infinity;
        const bNumber = b.jerseyNumber ?? Infinity;
        cmp = aNumber - bNumber;
      }
      return playersOrder.desc ? -cmp : cmp;
    });
    return sorted;
  };

  const togglePlayerSelected = (playerId) => {
    setSelectedPlayerIds((prev) =>
      prev.includes(playerId)
        ? prev.filter((id) => id !== playerId)
        : [...prev, playerId]
    );
  };

  const renderPlayers = (active = true) => {
    if (teamLoader) {
      return skeletonTableLoader(6, 8, 70);
    }

    return sortPlayers(
      players.filter((player) => !!player.active === active)
    ).map((player) => (
      <tr key={`renderPlayers-${player.id}`}>
        <td>
          <input
            type="checkbox"
            checked={selectedPlayerIds.includes(player.id)}
            onChange={() => togglePlayerSelected(player.id)}
            aria-label={`${player.firstname} ${player.lastname}`}
          />
        </td>
        <td>
          <div className="employee-cell">
            {player?.imageUrl ? (
              <img
                className="company__profile__avatar"
                src={player.imageUrl}
                alt="logo"
              />
            ) : (
              <span
                className="company__profile__avatar_placeholder"
                style={{
                  background: avatarColorFor(player?.position),
                }}
              >
                {initialsFor(player?.firstname, player?.lastname)}
              </span>
            )}
            <div>
              <Link to={`/players/${selectedTeam?.id}/edit/${player.id}`}>
                <strong>
                  {player.firstname} {player.lastname}
                </strong>
              </Link>
              <br />
              <small className="text-muted">{player.position}</small>
            </div>
          </div>
        </td>
        <td>{player.nationality}</td>
        <td>{player.jerseyNumber}</td>
        <td>
          <Badge pill color={player.companyId ? 'success' : 'secondary'}>
            {player.companyId ? s('sponsor') : s('noSponsor')}
          </Badge>
        </td>
        <td>
          <div className="icon-actions">
            <SquareIconButton
              icon={
                player.active ? (
                  <CloseCircleOutlineIcon />
                ) : (
                  <CheckCircleOutlineIcon />
                )
              }
              onClick={() => toggleActivePlayer(player)}
              title={
                player.active ? p('deactivatePlayer') : p('activatePlayer')
              }
              tone={player.active ? 'danger' : 'default'}
              id={`toggle-active-${player.id}`}
            />
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() =>
                history.push(`/players/${selectedTeam?.id}/edit/${player.id}`)
              }
              title={s('edit')}
              id={`edit-${player.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() => playerHandleModal(player.id)}
              title={s('delete')}
              tone="danger"
              id={`delete-${player.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };

  const renderGroups = () => {
    return groups.map((group, index) => (
      <Draggable
        key={`group-${group.id}`}
        draggableId={`group-${group.id}`}
        index={index}
        isDragDisabled={!!groupState}
      >
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={snapshot.isDragging ? 'rbdnd-dragging' : ''}
            key={`group-${group.id}`}
          >
            <td>
              <div className="flex-Vcenter">
                {!groupState && <DragIcon color="#99999" />}
                {group.name}
              </div>
            </td>
            <td>{group.values.join(',')}</td>
            <td>
              <UncontrolledDropdown className="dashboard__table-more">
                <DropdownToggle>
                  <DotsHorizontalIcon />
                </DropdownToggle>
                <DropdownMenu className="dropdown__menu">
                  <DropdownItem
                    onClick={() => setGroupState({ type: 'edit', ...group })}
                  >
                    {s('edit')}
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => groupHandleModal(group.id)}
                    className="danger"
                  >
                    {s('delete')}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </td>
          </tr>
        )}
      </Draggable>
    ));
  };

  const groupOnDragEnd = async ({ destination, source }) => {
    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    const draggedGroup = groups[source.index];
    const newGroups = [...groups];
    newGroups.splice(source.index, 1);
    newGroups.splice(destination.index, 0, draggedGroup);
    setGroups(newGroups);
    setLoadingGroup(true);
    const order = newGroups.map((group, index) => ({
      id: group.id,
      order: index,
    }));
    try {
      await Api.club.updateSettingsOrder({ settingOrders: order });
      setLoadingGroup(false);
    } catch (err) {
      toast.error(err || p('updatingOrderFailed'));
      // The reorder wasn't persisted - resync from the server so the
      // displayed order doesn't stay out of sync with what's saved.
      getGroups();
    }
  };

  const transfer = (team, player) => async () => {
    setLoadingTransfer(true);
    try {
      const res = await Api.players.transfer(team.id, player.id);
      if (res.statusText === 'OK' || (res.status >= 200 && res.status < 300)) {
        toast.success(`${player.fullname} transfered`);
        setSelectedTransferPlayer(undefined);
        await fetchTeam(team.id);
      }
    } catch (err) {
      toast.error(err || p('transferFailed'));
    }
    setLoadingTransfer(false);
  };

  const debounce = (cb) => {
    let id = '';
    return (value) => {
      clearTimeout(id);
      id = setTimeout(() => {
        cb(value);
      }, 400);
    };
  };

  const db = debounce(async (value) => {
    if (value.length > 2) {
      try {
        const { data: searchedPlayers } = await Api.players.search(
          value,
          selectedTeam.id
        );
        setSearchPlayers(searchedPlayers);
        setSelectedTransferPlayer(undefined);
      } catch (err) {
        toast.error(err || p('searchFailed'));
      }
    } else {
      setSearchPlayers([]);
    }
  });

  const onChange = (value) => {
    db(value);
  };

  const getPlayerUrl = (player) => {
    if (player.imageUrl && player.imageCrop) {
      return `${player.imageUrl}.webp?crop=${player.imageCrop.x},${player.imageCrop.y},${player.imageCrop.width},${player.imageCrop.height}`;
    }
    return player.currentTeam.noPlayerImageUrl;
  };

  const onSubmitGroup = async (values) => {
    setLoadingGroup(true);
    setGroupState(false);
    const updatedPositions = values.values?.map((value) => value.value) || [];
    const val = values.values || [];
    try {
      await Promise.all(
        groups
          .filter((group) => group.id !== values.id)
          .map((group) => {
            const vals = group.values.filter(
              (value) => !updatedPositions.includes(value)
            );
            return Api.club.editSetting({
              id: group.id,
              value: `${group.name}${vals.length > 0 ? `:${vals.join(':')}` : ''}`,
              order: group.order,
            });
          })
      );
      if (!values.id) {
        await Api.club.createSetting({
          key: 'playerGroup',
          value: `${values.name}${val.length > 0 ? `:${val.map((v) => v.value).join(':')}` : ''}`,
        });
        toast.success(p('groupCreated'));
      } else {
        await Api.club.editSetting({
          id: values.id,
          value: `${values.name}${val.length > 0 ? `:${val.map((v) => v.value).join(':')}` : ''}`,
          order: values.id,
        });
        toast.success(p('groupUpdated'));
      }
      getGroups();
    } catch (err) {
      toast.error(err || s('somethingWentWrong'));
      getGroups();
    }
  };
  const PlayersCard = ({ active }) => {
    const visiblePlayerIds = players
      .filter((player) => !!player.active === !!active)
      .map((player) => player.id);
    const allVisibleSelected =
      visiblePlayerIds.length > 0 &&
      visiblePlayerIds.every((id) => selectedPlayerIds.includes(id));

    const toggleSelectAllVisible = () => {
      if (allVisibleSelected) {
        setSelectedPlayerIds((prev) =>
          prev.filter((id) => !visiblePlayerIds.includes(id))
        );
      } else {
        setSelectedPlayerIds((prev) => [
          ...prev,
          ...visiblePlayerIds.filter((id) => !prev.includes(id)),
        ]);
      }
    };

    return (
      <Table responsive striped className="table--roomy">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={allVisibleSelected}
                onChange={toggleSelectAllVisible}
                aria-label={s('selectAll')}
              />
            </th>
            <th className="sortable" onClick={() => handleSort('name')}>
              <div className="flex alignItems-center">
                {s('name')} {renderSortIcon('name')}
              </div>
            </th>
            <th>{s('nationality')}</th>
            <th className="sortable" onClick={() => handleSort('jerseyNumber')}>
              <div className="flex alignItems-center">
                {s('shirtNumber')} {renderSortIcon('jerseyNumber')}
              </div>
            </th>
            <th>{s('sponsor')}</th>
            <th />
          </tr>
        </thead>
        <tbody>{renderPlayers(!!active)}</tbody>
      </Table>
    );
  };
  return (
    <Container>
      <Loading loading={loadingPlayer || loadingGroup || loadingTransfer} />
      <DeleteModal
        visible={playerVisible}
        type="spilleren"
        handleModal={playerHandleModal}
        modalAction={deletePlayer}
      />
      <DeleteModal
        visible={groupVisible}
        type="gruppen"
        handleModal={groupHandleModal}
        modalAction={deleteGroup}
      />
      <NavTab
        tabs={[s('players'), p('playerSettings'), p('teamSettings')]}
        activeTab={tab}
        setTab={setTab}
      />
      {tab === '1' && (
        <div className="pb-2">
          <InfoBox>{p('editingPlayersSlowInfo')}</InfoBox>
          <FormCard
            title={
              <>
                <div className="form-card__switch d-none d-md-inline-flex">
                  <button
                    type="button"
                    className={`form-card__switch-btn${
                      playersFilter === 'active' ? ' active' : ''
                    }`}
                    onClick={() => setPlayersFilter('active')}
                  >
                    {p('activePlayers')}
                  </button>
                  <button
                    type="button"
                    className={`form-card__switch-btn${
                      playersFilter === 'inactive' ? ' active' : ''
                    }`}
                    onClick={() => setPlayersFilter('inactive')}
                  >
                    {p('inactivePlayers')}
                  </button>
                </div>
                <span className="d-md-none">
                  {playersFilter === 'active'
                    ? p('activePlayers')
                    : p('inactivePlayers')}
                </span>
              </>
            }
            actions={
              <>
                <div
                  className="d-none d-md-flex align-items-center"
                  style={{ gap: 8 }}
                >
                  <Button
                    size="sm"
                    color="primary"
                    className="mb-0"
                    disabled={selectedPlayerIds.length === 0}
                    onClick={() =>
                      toggleActivePlayers(
                        selectedPlayerIds,
                        playersFilter !== 'active'
                      )
                    }
                  >
                    {playersFilter === 'active'
                      ? p('deactivateSelectedPlayers')
                      : p('activateSelectedPlayers')}{' '}
                    ({selectedPlayerIds.length})
                  </Button>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="icon icon--right mb-0"
                      outline
                      size="sm"
                    >
                      {selectedTeam?.name || `${s('filter')}`}{' '}
                      <ChevronDownIcon />
                    </DropdownToggle>
                    <DropdownMenu>
                      {config.teams.map((team) => (
                        <DropdownItem
                          key={`drpp${team.id}`}
                          onClick={_setSelectedTeam(team)}
                        >
                          {team.name}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <Link to={`/players/${selectedTeam?.id}/create`}>
                    <Button size="sm" color="primary" className="mb-0">
                      {p('createPlayer')}
                    </Button>
                  </Link>
                </div>
                <UncontrolledDropdown className="d-md-none">
                  <DropdownToggle
                    tag="button"
                    type="button"
                    className="square-icon-btn"
                    caret={false}
                  >
                    <DotsHorizontalIcon />
                  </DropdownToggle>
                  <DropdownMenu right className="dropdown-menu--modern">
                    <DropdownItem
                      active={playersFilter === 'active'}
                      onClick={() => setPlayersFilter('active')}
                    >
                      {p('activePlayers')}
                    </DropdownItem>
                    <DropdownItem
                      active={playersFilter === 'inactive'}
                      onClick={() => setPlayersFilter('inactive')}
                    >
                      {p('inactivePlayers')}
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      disabled={selectedPlayerIds.length === 0}
                      onClick={() =>
                        toggleActivePlayers(
                          selectedPlayerIds,
                          playersFilter !== 'active'
                        )
                      }
                    >
                      {playersFilter === 'active'
                        ? p('deactivateSelectedPlayers')
                        : p('activateSelectedPlayers')}{' '}
                      ({selectedPlayerIds.length})
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to={`/players/${selectedTeam?.id}/create`}
                    >
                      {p('createPlayer')}
                    </DropdownItem>
                    <DropdownItem divider />
                    {config.teams.map((team) => (
                      <DropdownItem
                        key={`mdrpp${team.id}`}
                        onClick={_setSelectedTeam(team)}
                      >
                        {team.name}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </>
            }
            bodyClassName="form-card__body--flush"
            className="mb-3"
          >
            <PlayersCard active={playersFilter === 'active'} />
          </FormCard>
        </div>
      )}
      {tab === '2' && (
        <>
          <div className="flex space-between">
            <h3 className="page-title mb-2">{s('groups')}</h3>
            <Button
              className="mb-2"
              onClick={() => setGroupState({ type: 'create' })}
              size="sm"
              color="primary"
            >
              {p('createGroup')}
            </Button>
          </div>
          {groupState ? (
            <Card>
              <CardBody>
                <GroupForm
                  group={groupState}
                  positions={positions}
                  onSubmit={onSubmitGroup}
                  cancel={() => setGroupState(false)}
                />
              </CardBody>
            </Card>
          ) : (
            <div
              style={{
                display: 'flex',
                paddingBottom: 5,
                marginBottom: 10,
                background: '#fff',
                borderRadius: 6,
                boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
              }}
            >
              <DragDropContext onDragEnd={groupOnDragEnd}>
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>{s('groupName')}</th>
                      <th>Mapped positions</th>
                      <th />
                    </tr>
                  </thead>
                  <Droppable droppableId="group-dnd">
                    {(provided) => {
                      return (
                        <>
                          <tbody
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {renderGroups()}
                            {provided.placeholder}
                          </tbody>
                        </>
                      );
                    }}
                  </Droppable>
                </Table>
              </DragDropContext>
            </div>
          )}
          <Card>
            <CardHeader>{p('transferPlayers')}</CardHeader>
            <CardBody>
              <Row>
                <Col md={2}>
                  <Select
                    menuRenderer={({ options, onSelect }) => {
                      return (
                        <div className="Select-menu">
                          {options.map((option) => (
                            <div
                              className="Select-option"
                              key={option.value}
                              onClick={() => onSelect(option)}
                            >
                              {option.label}
                              <img
                                src={option.currentTeam.logoUrl}
                                alt=""
                                style={{
                                  width: '20px',
                                  height: 'auto',
                                  float: 'right',
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      );
                    }}
                    value={selectedTransferPlayer}
                    onChange={selectTransferPlayer}
                    onInputChange={onChange}
                    options={searchPlayers.map((player) => ({
                      ...player,
                      label: player.fullname,
                      value: player.id,
                    }))}
                  />
                </Col>
              </Row>
              {selectedTransferPlayer && (
                <Row style={{ marginTop: '20px' }}>
                  <Col md={6}>
                    <Toast>
                      <ToastHeader
                        icon={
                          <img
                            src={getPlayerUrl(selectedTransferPlayer)}
                            width="10"
                            alt=""
                          />
                        }
                      >
                        {selectedTransferPlayer.fullname}
                      </ToastHeader>
                      <ToastBody>
                        <h3>{`${p('fromTeam')}: ${selectedTransferPlayer.currentTeam.name}`}</h3>
                        <h3>{`${p('toTeam')}: ${selectedTeam.name}`}</h3>
                        <Button
                          color="primary"
                          disabled={loadingTransfer}
                          onClick={transfer(
                            selectedTeam,
                            selectedTransferPlayer
                          )}
                        >
                          Transfer
                        </Button>
                      </ToastBody>
                    </Toast>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </>
      )}
      {tab === '3' && <TeamProfileList />}
    </Container>
  );
};
export default PlayersListPage;
